enum ConsentsTypes {
  General = 'general',
  BrandDataSharing = 'brand_data_sharing',
  BrandEmailMarketing = 'brand_email_marketing',
  ThirdPartyDataSharing = '3rdparty_data_sharing'
}

export default ConsentsTypes;
